<script setup>
    import { useWebStore } from '~/store/web';
    const store = useWebStore();
    const showDocument = ref(false)
    const shownDocument = ref('')
    store.chosenTab = store.sites[6].url

    const AsyncPdf = defineAsyncComponent(() => import('../components/pdf.vue'));

    
</script>
<template>
        <div class="p-8 h-3/4 w-1/2 mx-auto bg-white">
            <h1 class="InterExtraBold text-4xl mb-6">{{store.getLocaleString('dp1')}}</h1>
            <div class="grid grid-cols-1 auto-rows-fr p-1 gap-4 mt-5  xl:gap-10 xl:mb-7">
                <div v-for="category of store.locale.current.dataPrivacyCategories" @click="shownDocument = category.document; showDocument = true;" class="w-full flex cursor-pointer shadow-xl hover:shadow-2xl ease-in duration-300 items-center rounded p-4 bg-slate-50">
                    <h3 class="text-black text-left dark:text-white text-2xl InterMedium border-black w-max h-max ">{{ category.title }}</h3>
                        <UIcon name="i-heroicons-document" class="w-7 h-7 ml-auto bg-orange-500"/>
                </div>
            </div>
        </div>
        <ClientOnly>
            <UModal v-model="showDocument"
                    :ui="{width:'w-full sm:max-w-3xl',margin: 'sm:my-24', padding: 'p-4 sm:p-2'}"
                    >
                <div class="p-4 w-max mx-auto h-2/6 mt-2 flex flex-col gap-5">
                    <UButton color="gray" variant="ghost" icon="i-heroicons-x-mark-20-solid" size="xl" class="ml-auto mr-1 p-0" @click="showDocument = false" />
                    <AsyncPdf class="" :url="shownDocument"/>
                </div>
            </UModal>
        </ClientOnly>
        <FooterComp/>
</template>